<template>
	<form v-on:submit.prevent="saveApplicant">
		<fieldset>
			<legend><i class="fad fa-portrait"></i> Personal Info</legend>
			<div class="label-field">
				<div class="field-group">
					<div>
						<label for="nameFirst">
							<i class="fad fa-user"></i> First Name
						</label>
						<input id="nameFirst" v-model="nameFirst" type="text" minlength="2" required />
					</div>
					<div>
						<label for="nameLast">
							<i class="fad fa-user"></i> Last Name
						</label>
						<input id="nameLast" v-model="nameLast" type="text" minlength="2" required />
					</div>
				</div>
			</div>
			<div class="label-field">
				<label for="pronouns">
					<i class="fad fa-user-alt"></i> Preferred Pronouns
				</label>
				<input id="pronouns" v-model="pronouns" type="text" required />
			</div>
			<div class="label-field">
				<label for="address">
					<i class="fad fa-address-card"></i> Address
				</label>
				<input id="address" v-model="address.line1" type="text" minlength="6" required />
			</div>
			<div class="label-field">
				<div class="field-group field-group-alt">
					<div>
						<label for="city">
							<i class="fad fa-city"></i> City
						</label>
						<input id="city" v-model="address.city" type="text" minlength="3" required />
					</div>
					<div>
						<label for="state">
							<i class="fad fa-flag-usa"></i> State
						</label>
						<input id="state" v-model="address.state" type="text" size="2" minlength="2" maxlength="2" required />
					</div>
					<div>
						<label for="zip">
							<i class="fad fa-map-pin"></i> Zip
						</label>
						<input id="zip" v-model="address.zip" type="text" size="5" minlength="5" maxlength="10" required />
					</div>
				</div>
			</div>
			<div class="label-field">
				<label for="email">
					<i class="fad fa-at"></i> Email
				</label>
				<input id="email" v-model="email" type="email" minlength="9" required />
			</div>
			<div class="label-field">
				<label for="phone">
					<i class="fad fa-mobile"></i> Phone <span>(10 digits)</span>
				</label>
				<input id="phone" v-model="phone" type="tel" placeholder="2125552021" minlength="10" required />
			</div>
			<div class="label-field">
				<label for="citizen">
					<i class="fad fa-id-card"></i> US Citizen or Permanent Resident Status
				</label>
				<div class="field-group field-group-radio-checkbox">
					<div>
						<label for="citizen-yes">
							<input id="citizen-yes" name="citizen" value="true" v-model="citizen" type="radio" required />
							<i class="fad fa-circle-notch"></i>
							<i class="fad fa-dot-circle"></i>
							<span>Yes</span>
						</label>
					</div>
					<div>
						<label for="citizen-no">
							<input v-on:click="citizenship" id="citizen-no" name="citizen" value="false" v-model="citizen" type="radio" required />
							<i class="fad fa-circle-notch"></i>
							<i class="fad fa-dot-circle"></i>
							<span>No</span>
						</label>
					</div>
				</div>
			</div>
			<div class="label-field">
				<label for="dob">
					<i class="fad fa-birthday-cake"></i> DOB
				</label>
				<input id="dob" v-model="dob" type="date" placeholder="YYYY-MM-DD" minlength="10" maxlength="10" min="1998-05-02" required /> <span class="err" v-if="dobMsg.length > 1">{{dobMsg}}</span>
			</div>
			<div class="label-field">
				<label for="school">
					<i class="fad fa-school"></i> Name of High School, College or University most recently attended and/or graduated from
				</label>
				<input id="school" v-model="school" type="text" minlength="3" required />
			</div>
		</fieldset>
		<fieldset>
			<legend>
				<i class="fad fa-file-invoice-dollar"></i> Financial Information
			</legend>
			<div class="label-field">
				<label for="income">
					<i class="fad fa-dollar-sign"></i> Income
				</label>
				<p>Please select your Yearly Earned Income. This is income that you've made as a W2 Employee or 1099 Contractor in the past year.</p>
				<select name="income" v-model="income">
					<option value="$0-$10,000">$0-$10,000</option>
					<option value="$10,001-$20,000">$10,001-$20,000</option>
					<option value="$20,001-$30,000">$20,001-$30,000</option>
					<option value="$30,001+">$30,001+</option>
				</select>
			</div>
			<div class="label-field label-field-checkbox">
				<label for="income">
					<i class="fad fa-coin"></i> Other Income
				</label>
				<p>Do you have other sources of income or financial support? Please check all that apply. If you have other types of income, please fill out the "other" box below with more details.</p>
				<div class="field-group field-group-radio-checkbox">
					<div>
						<label for="otherinc-support">
							<input id="otherinc-support" v-model="otherInc.support" type="checkbox" />
							<i class="fad fa-square"></i>
							<i class="fad fa-check-square"></i>
							<span>
								Financial Support from Family and/or Friends
							</span>
						</label>
					</div>
				</div>
			</div>
			<div class="label-field label-field-checkbox">
				<div class="field-group field-group-radio-checkbox">
					<div>
						<label for="otherinc-savings">
							<input id="otherinc-savings" v-model="otherInc.savings" type="checkbox" />
							<i class="fad fa-square"></i>
							<i class="fad fa-check-square"></i>
							<span>
								Savings
							</span>
						</label>
					</div>
				</div>
			</div>
			<div class="label-field label-field-checkbox">
				<div class="field-group field-group-radio-checkbox">
					<div>
						<label for="otherinc-loans">
							<input id="otherinc-loans" v-model="otherInc.loans" type="checkbox" />
							<i class="fad fa-square"></i>
							<i class="fad fa-check-square"></i>
							<span>
								Loans
							</span>
						</label>
					</div>
				</div>
			</div>
			<div class="label-field label-field-checkbox">
				<div class="field-group field-group-radio-checkbox">
					<div>
						<label for="otherinc-existing">
							<input id="otherinc-existing" v-model="otherInc.existing" type="checkbox" />
							<i class="fad fa-square"></i>
							<i class="fad fa-check-square"></i>
							<span>
								Existing Grants/Scholarships
							</span>
						</label>
					</div>
				</div>
			</div>
			<div class="label-field label-field-checkbox">
				<div class="field-group field-group-radio-checkbox">
					<div>
						<label for="otherinc-investments">
							<input id="otherinc-investments" v-model="otherInc.investments" type="checkbox" />
							<i class="fad fa-square"></i>
							<i class="fad fa-check-square"></i>
							<span>
								Investments
							</span>
						</label>
					</div>
				</div>
			</div>
			<div class="label-field label-field-checkbox">
				<div class="field-group field-group-radio-checkbox">
					<div>
						<label for="otherinc-other">
							<input v-on:click="otherDetail" id="otherinc-other" v-model="otherInc.other" type="checkbox" />
							<i class="fad fa-square"></i>
							<i class="fad fa-check-square"></i>
							<span>
								Other
							</span>
						</label>
					</div>
				</div>
			</div>
			<div v-if="otherDetails" class="label-field">
				<input id="otherinc-detail" v-model="otherInc.detail" type="text" minlength="6" required />
			</div>
		</fieldset>

		<fieldset>
			<legend>
				<i class="fad fa-photo-video"></i> Video Essay Submission - Tier 1
			</legend>
			<p>Record and share a one-minute video response to the below prompt. &mdash;  <strong>1 Minute Total</strong></p>
			<h3>
				Describe how being our Ann Reinking Scholarship winner would contribute to your career goal(s) and why being located in NYC is important to you.
			</h3>
			<div class="label-field">
				<label for="goal-file">
					<i class="fad fa-file-upload"></i> Upload a video <span>(.mp4/.mov, &lt; 150mb)</span>
				</label>
				<div v-if="videoGoal.uploading">
					<span v-if="videoGoal.progress">{{videoGoal.progress}}%</span> uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!videoGoal.file"><input data-model="videoGoal" data-attr="file" data-type="video" id="goal-file" type="file" accept="video/*" v-on:change="fileAttachment"  /></div><div v-else> &nbsp; <strong>{{videoGoal.file.name}}</strong></div>
				</div>

					<div v-if="isPrivate">
						<div v-if="videoGoal.file">
							Current Upload: <strong>videoGoal.file</strong>
						</div>
					</div>

				<div class="or">&mdash;OR&mdash;</div>
				<label for="goal-url">
					<i class="fad fa-link"></i> Share YouTube/Vimeo Link<br />
				</label>
				<input id="goal-url" class="file-url" type="url" v-model="videoGoal.url" placeholder="https://youtu.be/uNiQuE_uRl_HeRe" >
				<p><strong>*Disclaimer: To ensure your application is viewed in full by Adjudicators, please adhere to time requirements and limitations.</strong></p>
			</div>
		</fieldset>

		<fieldset>
			<legend>
				<i class="fad fa-star"></i> Dance Piece Submission - Tier 1
			</legend>
			<p>
				The dance piece may be choreographed or self-choreographed and filmed in performance or in studio. Solo work is preferred.  If the video has more than one dancer, it should be clear which one is you. Please notate this in the Description of the Video. (eg. I am the one wearing the blue leotard. I am the dancer furthest stage right at the beginning of the video.)
			</p>
			<h3>
				Record and share TWO contrasting dance pieces not to exceed four minutes in total. Please edit these videos together into one file. &mdash; <strong>4 Minutes Total</strong>
			</h3>
			<div class="label-field">
				<label for="dance-file">
					<i class="fad fa-file-upload"></i> Upload a video <span>(.mp4/.mov, &lt; 750mb)</span>
				</label>
				<div v-if="videoDance.uploading">
					<span v-if="videoDance.progress">{{videoDance.progress}}%</span> uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!videoDance.file"><input data-model="videoDance" data-attr="file" data-type="video" id="dance-file" type="file" accept="video/*" v-on:change="fileAttachment"  /></div><div v-else> &nbsp; <strong>{{videoDance.file.name}}</strong></div>
				</div>

					<div v-if="isPrivate">
						<div v-if="videoDance.file">
							Current Upload: <strong>videoDance.file</strong>
						</div>
					</div>


				<div class="or">&mdash;OR&mdash;</div>
				<label for="dance-url">
					<i class="fad fa-link"></i> Share YouTube/Vimeo Link<br />
				</label>
				<input data-model="videoDance" data-type="video" id="dance-url" class="file-url" type="url" v-model="videoDance.url" placeholder="https://youtu.be/uNiQuE_uRl_HeRe" >
				<p><strong>*Disclaimer: To ensure your application is viewed in full by Adjudicators, please adhere to time requirements and limitations.</strong></p>
			</div>
			<div class="or">&mdash;AND&mdash;</div>
			<div class="label-field">
				<label for="dance-file">
					<i class="fad fa-comment-alt-lines"></i> Description of Dance Piece
				</label>
				<p>Please notate anything we need to know about the video. (Ex: Clarifying which dancer is you, if the piece is Self Choreographed, etc)  </p>
				<textarea id="dance-description" v-model="videoDance.description" rows="6"></textarea>
			</div>
		</fieldset>

		<fieldset>
			<legend>
				<i class="fad fa-photo-video"></i> Video Essay Submission - Tier 2
			</legend>
			<p>Record and share a one-minute video response to the below prompt. &mdash;  <strong>1  Minute Total</strong></p>
			<h3>
				What is your plan to use this scholarship and mentoring opportunity to live in NYC for one year?
			</h3>
			<div class="label-field">
				<label for="essay-file">
					<i class="fad fa-file-upload"></i> Upload a video <span>(.mp4/.mov, &lt; 150mb)</span>
				</label>
				<div v-if="videoEssay.uploading">
					<span v-if="videoEssay.progress">{{videoEssay.progress}}%</span> uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!videoEssay.file"><input data-model="videoEssay" data-attr="file" data-type="video" id="essay-file" type="file" accept="video/*" v-on:change="fileAttachment"  /></div><div v-else> &nbsp; <strong>{{videoEssay.file.name}}</strong></div>
				</div>

				<div v-if="videoEssay.file">
					Current Upload: <strong>videoEssay.file</strong>
				</div>


				<div class="or">&mdash;OR&mdash;</div>
				<label for="essay-url">
					<i class="fad fa-link"></i> Share YouTube/Vimeo Link<br />
				</label>
				<input id="essay-url" class="file-url" type="url" v-model="videoEssay.url" placeholder="https://youtu.be/uNiQuE_uRl_HeRe" >
				<p><strong>*Disclaimer: To ensure your application is viewed in full by Adjudicators, please adhere to time requirements and limitations.</strong></p>
			</div>
		</fieldset>
		<fieldset>
			<legend>
				<i class="fad fa-star"></i> Dance Piece Submission - Tier 2
			</legend>
			<p>
				Work samples may be excerpts from longer dances either choreographed or self-choreographed and filmed in performance or in studio. 
			</p>
			<p>
				Solo work is preferred. If the piece is not a solo, identify which dancer is you. Please notate this in the Description. (eg. I am wearing the blue leotard or, I am the dancer furthest stage right at the beginning of the video.)
			</p>
			<p>
				These work samples should be filmed recently and should not be more than one year old.
			</p>
			<p>
				You do have the option to use the same dance pieces uploaded to Tier 1 of your application if you so choose.
			</p>
			<h3>
				Upload up to THREE contrasting dance pieces not to exceed six minutes in total. Please edit these pieces together into one file or YouTube Video. &mdash; <strong>6 Minutes Total</strong>
			</h3>
			<div class="label-field">
				<label for="dance2-file">
					<i class="fad fa-file-upload"></i> Upload a video <span>(.mp4/.mov, &lt; 840mb)</span>
				</label>
				<div v-if="videoDance2.uploading">
					<span v-if="videoDance2.progress">{{videoDance2.progress}}%</span> uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!videoDance2.file"><input data-model="videoDance2" data-attr="file" data-type="video" id="dance2-file" type="file" accept="video/*" v-on:change="fileAttachment"  /></div><div v-else> &nbsp; <strong>{{videoDance2.file.name}}</strong></div>
				</div>

				<div v-if="videoDance2.file">
					Current Upload: <strong>videoDance2.file</strong>
				</div>

				<div class="or">&mdash;OR&mdash;</div>
				<label for="dance2-url">
					<i class="fad fa-link"></i> Share YouTube/Vimeo Link<br />
				</label>
				<input data-model="videoDance2" data-type="video" id="dance2-url" class="file-url" type="url" v-model="videoDance2.url" placeholder="https://youtu.be/uNiQuE_uRl_HeRe" >
				<p><strong>*Disclaimer: To ensure your application is viewed in full by Adjudicators, please adhere to time requirements and limitations.</strong></p>
			</div>
			<div class="or">&mdash;AND&mdash;</div>
			<div class="label-field">
				<label for="dance2-file">
					<i class="fad fa-comment-alt-lines"></i> Description of Dance Piece
				</label>
				<p>Please notate information helpful to the adjudicators in viewing your work sample. (Name of the choreographer, if it is self-choreographed, and please identify yourself in group work)</p>
				<textarea id="dance2-description" v-model="videoDance2.description" rows="6"></textarea>
			</div>
		</fieldset>

		<fieldset>
			<legend>
				<i class="fad fa-file-user"></i> Additional Materials - Tier 1
			</legend>
			<p>Please provide a headshot, resume, and one letter of recommendation.</p>
			<div class="label-field">
				<label for="headshot">
					<i class="fad fa-file-image"></i> Headshot <span>(jpg/png, &lt; 20mb)</span>
				</label>
				<div v-if="materials.uploading">
					uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!materials.headshot"><input data-model="materials" data-attr="headshot" data-type="document" id="headshot-file" type="file" accept="image/jpeg,image/png" v-on:change="fileAttachment" required  /></div><div v-else> &nbsp; <strong>{{materials.headshot.name}}</strong></div>
				</div>

					<div v-if="isPrivate">
						<div v-if="materials.headshot">
							Current Upload: <strong>{{materials.headshot}}</strong>
						</div>
					</div>

			</div>
			<div class="label-field">
				<label for="resume">
					<i class="fad fa-file-pdf"></i> Resume <span>(pdf, &lt; 10mb)</span>
				</label>
				<div v-if="materials.uploading">
					uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!materials.resume"><input data-model="materials" data-attr="resume" data-type="document" id="resume-file" type="file" accept="application/pdf" v-on:change="fileAttachment" required  /></div><div v-else> &nbsp; <strong>{{materials.resume.name}}</strong></div>
				</div>

					<div v-if="isPrivate">
						<div v-if="materials.resume">
							Current Upload: <strong>{{materials.resume}}</strong>
						</div>
					</div>

			</div>
			<div class="label-field">
				<label for="letter">
					<i class="fad fa-file-pdf"></i> Letter of Recommendation <span>(pdf, &lt; 10mb)</span>
				</label>
				<div v-if="materials.uploading">
					uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!materials.letter"><input data-model="materials" data-attr="letter" data-type="document" id="letter-file" type="file" accept="application/pdf" v-on:change="fileAttachment" required  /></div><div v-else> &nbsp; <strong>{{materials.letter.name}}</strong></div>
				</div>

					<div v-if="isPrivate">
						<div v-if="materials.letter">
							Current Upload: <strong>{{materials.letter}}</strong>
						</div>
					</div>

			</div>
		</fieldset>
		<fieldset>
			<legend>
				<i class="fad fa-file-user"></i> Additional Materials - Tier 2
			</legend>
			<div class="label-field">
				<label for="budget">
					<i class="fad fa-file-pdf"></i> Budget <span>(pdf &lt; 10mb)</span>
				</label>
				<div v-if="materials.uploading">
					uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!materials.budget"><input data-model="materials" data-attr="budget" data-type="document" id="budget-file" type="file" accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf" v-on:change="fileAttachment" required  /></div><div v-else> &nbsp; <strong>{{materials.budget.name}}</strong></div>
				</div>

					<div v-if="isPrivate">
						<div v-if="materials.budget">
							Current Upload: <strong>{{materials.budget}}</strong>
						</div>
					</div>

			</div>
			<div class="label-field">
				<label for="tax">
					<i class="fad fa-file-pdf"></i> Tax <span>(.pdf &lt; 20mb)</span>
				</label>
				<div v-if="materials.uploading">
					uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!materials.tax"><input data-model="materials" data-attr="tax" data-type="document" id="tax-file" type="file" accept="application/pdf" v-on:change="fileAttachment" required  /></div><div v-else> &nbsp; <strong>{{materials.tax.name}}</strong></div>
				</div>

				<div v-if="isPrivate">
					<div v-if="materials.tax">
						Current Upload: <strong>{{materials.tax}}</strong>
					</div>
				</div>
			</div>

			<div class="label-field">
				<label for="bank1">
					<i class="fad fa-file-pdf"></i> Bank #1 <span>(.pdf &lt; 10mb)</span>
				</label>
				<div v-if="materials.uploading">
					uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!materials.bank1"><input data-model="materials" data-attr="bank1" data-type="document" id="bank1-file" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf" v-on:change="fileAttachment" required  /></div><div v-else> &nbsp; <strong>{{materials.bank1.name}}</strong></div>
				</div>

				<div v-if="isPrivate">
					<div v-if="materials.bank1">
						Current Upload: <strong>{{materials.bank1}}</strong>
					</div>
				</div>

			</div>
			<div class="label-field">
				<label for="bank2">
					<i class="fad fa-file-pdf"></i> Bank #2 <span>(.pdf &lt; 10mb)</span>
				</label>
				<div v-if="materials.uploading">
					uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!materials.bank2"><input data-model="materials" data-attr="bank2" data-type="document" id="bank2-file" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf" v-on:change="fileAttachment" required  /></div><div v-else> &nbsp; <strong>{{materials.bank2.name}}</strong></div>
				</div>

				<div v-if="isPrivate">
					<div v-if="materials.bank2">
						Current Upload: <strong>{{materials.bank2}}</strong>
					</div>
				</div>

			</div>


		</fieldset>
		<fieldset>
			<legend><i class="fad fa-file-contract"></i> Terms and Consent</legend>
			<div class="label-field label-field-checkbox">
				<div class="field-group field-group-radio-checkbox">
					<div>
						<label for="consent">
							<input id="consent" v-model="consent" type="checkbox" required />
							<i class="fad fa-square"></i>
							<i class="fad fa-check-square"></i>
							<span>
								I consent to having my information stored and filed. All information will be kept confidential.
							</span>
						</label>
					</div>
				</div>
			</div>
			<div class="label-field label-field-checkbox">
				<div class="field-group field-group-radio-checkbox">
					<div>
						<label for="confirm">
							<input id="confirm" v-model="confirm" type="checkbox" required />
							<i class="fad fa-square"></i>
							<i class="fad fa-check-square"></i>
							<span>
								I confirm that I have financial need for this scholarship and  understand that if I move to Tier 2 of the application process that I will have to supply documentation.
							</span>
						</label>
					</div>
				</div>
			</div>
		</fieldset>
		<fieldset v-if="isPrivate">
			<legend>
				<i class="fad fa-user-shield"></i> Internal
			</legend>
			<dl>
				<dt>External ID:</dt>
				<dd>{{appId}}</dd>
				<dt>Internal ID:</dt>
				<dd>{{altId}}</dd>
				<dt>User:</dt>
				<dd>
					<span v-if="user">{{user}}</span>
					<strong v-else class="warning">No Assigned User</strong>
				</dd>
			</dl>
			<div class="label-field">
				<label for="status"></label>
				<select name="status" v-model="status">
					<option value="submitted">Submitted</option>
					<option value="incomplete">Incomplete</option>
					<option value="approved">Approved</option>
					<option value="tier1">Tier 1</option>
					<option value="tier2">Tier 2</option>
					<option value="denied">Denied</option>
				</select>
			</div>
			<div class="label-field">
				<label for="notes">Internal Notes</label>
				<textarea name="notes" id="notes" v-model="notes" rows="6"></textarea>
			</div>
		</fieldset>
		<fieldset>
			<div v-if="isLoading"><i class="fad fa-spinner-third fa-spin fa-2x"></i></div>
			<div v-else class="label-field">
				<button v-bind:disabled="!consent || !confirm">
					<span>SUBMIT</span> <i class="fad fa-angle-right fa-fw"></i>
				</button>
			</div>
		</fieldset>
	</form>
</template>
<script>
const alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVZ'
const nanoidAlt = customAlphabet(alphabet, 12)
import { projectStorage } from '../firebase/config'
import { customAlphabet } from 'nanoid'
export default {
	emits: ['save-applicant'],
	props: {
		isLoading: {
			type: Boolean
		},
		isPrivate: {
			type: Boolean
		},
		crud: {
			type: String,
			required: true
		},
		applicant: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			appId: this.applicant.appId || null,
			altId: this.applicant.altId || nanoidAlt(),
			nameFirst: this.applicant.nameFirst || null,
			nameLast: this.applicant.nameLast || null,
			pronouns: this.applicant.pronouns || null,
			address: {
				line1: this.applicant.address.line1 || null,
				city: this.applicant.address.city || null,
				state: this.applicant.address.state || null,
				zip: this.applicant.address.zip || null
			},
			email: this.applicant.email || null,
			phone: this.applicant.phone || null,
			citizen: this.applicant.citizen || null,
			dob: this.applicant.dob || null,
			school: this.applicant.school || null,
			income: this.applicant.income || null,
			otherInc: {
				support: this.applicant.otherInc.support || null,
				savings: this.applicant.otherInc.savings || null,
				loans: this.applicant.otherInc.loans || null,
				existing: this.applicant.otherInc.existing || null,
				investments: this.applicant.otherInc.investments || null,
				other: this.applicant.otherInc.other || null,
				detail: this.applicant.otherInc.detail || null
			},
			otherDetails: this.applicant.otherInc.detail || null,
			videoGoal: {
				file: this.applicant.videoGoal.file || null,
				url: this.applicant.videoGoal.url || null,
				uploading: false,
				progress: null
			},
			videoDance: {
				file: this.applicant.videoDance.file || null,
				url: this.applicant.videoDance.url || null,
				description: this.applicant.videoDance.description || null,
				uploading: false,
				progress: null
			},
			materials: {
				headshot: this.applicant.materials.headshot || null,
				resume: this.applicant.materials.resume || null,
				letter: this.applicant.materials.letter || null,
				tax: this.applicant.materials.tax || null,
				bank1: this.applicant.materials.bank1 || null,
				bank2: this.applicant.materials.bank2 || null,
				budget: this.applicant.materials.budget || null,
				uploading: false,
				progress: null
			},
			videoEssay: {
				file: this.applicant.videoEssay !== undefined ? this.applicant.videoEssay.file : null,
				url: this.applicant.videoEssay !== undefined ? this.applicant.videoEssay.url : null,
				uploading: false,
				progress: null
			},
			videoDance2: {
				file: this.applicant.videoDance2 !== undefined ? this.applicant.videoDance2.file : null,
				url: this.applicant.videoDance2 !== undefined ? this.applicant.videoDance2.url : null,
				description: this.applicant.videoDance2 !== undefined ? this.applicant.videoDance2.description : null,
				uploading: false,
				progress: null
			},
			consent: this.applicant.consent || null,
			confirm: this.applicant.confirm || null,
			status: this.applicant.status || null,
			notes: this.applicant.notes || null,
			user: this.applicant.user || null,
			dateCreated: this.applicant.dateCreated || null,
			validated: true
		}
	},
	watch: {

	},
	computed: {
		dobMsg(){
			if(this.dob){
				if(this.dob.length === 10 & this.dob < '1998-05-02'){
					return 'You are not Eligible'
				} else {
					return ''
				}
			} else {
				return ''
			}
		}
	},
	methods: {
		citizenship(){
			alert('You must be eligible to live and work in the US in order to receive this grant of money. Should your status change, don\'t hesitate to reapply.')
		},
		otherDetail(){
			this.otherDetails = !this.otherDetails;
		},
		fileAttachment(e){
			let dataModel = e.target.getAttribute('data-model')
			let dataAttr = e.target.getAttribute('data-attr')
			let dataType = e.target.getAttribute('data-type')
			let fileUpload = e.target.files[0]
			let videoTypes = ['video/quicktime','video/mp4','video/wav','video/mp4']
			let fileTypes = ['image/png','image/jpeg','application/pdf']

			if(dataModel && fileUpload){

				this.[dataModel].uploading = true
				this.[dataModel].[dataAttr] = fileUpload
				let folder = 'documents'

				if(dataAttr === 'file'){
					folder = 'videos'
				}

				var folder_path = `applicants/${this.altId}/${folder}/${fileUpload.name}`
				const storageRef = projectStorage.ref(folder_path)
				let uploadTask = null

				if(dataType === 'video'){
					if(fileUpload.size < 849346560 && videoTypes.includes(fileUpload.type)){
						try {
							uploadTask = storageRef.put(fileUpload)
						} catch (error) {
							alert(error)
						} finally {
							//this.[dataModel].uploading = false
						}
					} else {
						this.[dataModel].[dataAttr] = null
						alert('File is too large or is NOT supported :(')
						//this.[dataModel].uploading = false
					}
				} else if(dataType === 'document'){
					if(fileUpload.size < 188743680 && fileTypes.includes(fileUpload.type)){
						try {
							uploadTask = storageRef.put(fileUpload)
						} catch (error) {
							alert(error)
						} finally {
							//this.[dataModel].uploading = false
						}
					} else {
						alert('File is too large or is NOT supported :(')
						//this.[dataModel].uploading = false
					}
				} else {
					alert('an error has occured :(')
				}

				uploadTask.on('state_changed', 
					(snapshot) => {
						this.[dataModel].progress = parseFloat((snapshot.bytesTransferred / snapshot.totalBytes) * 100).toFixed(2)
						// switch (snapshot.state) {
						// 	case projectStorage.TaskState.PAUSED: // or 'paused'
						// 		console.log('Upload is paused');
						// 		break;
						// 	case projectStorage.TaskState.RUNNING: // or 'running'
						// 		console.log('Upload is running');
						// 		break;
						// }
					}, 
					(error) => {
						alert( error )
					}, 
					() => {
						//uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
						//	console.log('File available at', downloadURL);
							this.[dataModel].uploading = false
						//});
					}
				);


			}
		},
		saveApplicant(){

			let addressObj = {
				line1: this.address.line1,
				line2: this.address.line2,
				city: this.address.city,
				state: this.address.state,
				zip: this.address.zip
			}

				addressObj = Object.keys(addressObj)
				.filter((k) => addressObj[k] != null)
				.reduce((a, k) => ({ ...a, [k]: addressObj[k] }), {})

			var video_goal_file_name = null

			if(this.videoGoal.file){
				video_goal_file_name = this.videoGoal.file.name || this.videoGoal.file
			}

			let videoGoalObj = {
				file: video_goal_file_name,
				url: this.videoGoal.url || null,
			}

				videoGoalObj = Object.keys(videoGoalObj)
				.filter((k) => videoGoalObj[k] != null)
				.reduce((a, k) => ({ ...a, [k]: videoGoalObj[k] }), {})



			var video_dance_file_name = null

			if(this.videoDance.file){
				video_dance_file_name = this.videoDance.file.name || this.videoDance.file
			}

			let videoDanceObj = {
				file:  video_dance_file_name,
				url: this.videoDance.url || null,
				description: this.videoDance.description || null
			}

				videoDanceObj = Object.keys(videoDanceObj)
				.filter((k) => videoDanceObj[k] != null)
				.reduce((a, k) => ({ ...a, [k]: videoDanceObj[k] }), {})

			let materialsObj = {
				headshot: this.materials.headshot.name || this.materials.headshot,
				resume: this.materials.resume.name || this.materials.resume,
				letter: this.materials.letter.name|| this.materials.letter,
				budget: this.materials.budget.name|| this.materials.budget,
				tax: this.materials.tax.name|| this.materials.tax,
				bank1: this.materials.bank1.name|| this.materials.bank1,
				bank2: this.materials.bank2.name|| this.materials.bank2
			}

				materialsObj = Object.keys(materialsObj)
				.filter((k) => materialsObj[k] != null)
				.reduce((a, k) => ({ ...a, [k]: materialsObj[k] }), {})

			var video_essay_file_name = null

			if(this.videoEssay.file){
				video_essay_file_name = this.videoEssay.file.name || this.videoEssay.file
			}

			let videoEssayObj = {
				file: video_essay_file_name,
				url: this.videoEssay.url || null
			}

				videoEssayObj = Object.keys(videoEssayObj)
				.filter((k) => videoEssayObj[k] != null)
				.reduce((a, k) => ({ ...a, [k]: videoEssayObj[k] }), {})


			var video_dance2_file_name = null

			if(this.videoDance2.file){
				video_dance2_file_name = this.videoDance2.file.name || this.videoDance2.file
			}

			let videoDance2Obj = {
				file: video_dance2_file_name,
				url: this.videoDance2.url || null,
				description: this.videoDance2.description || null
			}

				videoDance2Obj = Object.keys(videoDance2Obj)
				.filter((k) => videoDance2Obj[k] != null)
				.reduce((a, k) => ({ ...a, [k]: videoDance2Obj[k] }), {})




			let otherInc = {
				support: this.otherInc.support,
				savings: this.otherInc.savings,
				existing: this.otherInc.existing,
				investments: this.otherInc.investments,
				other: this.otherInc.other,
				detail: this.otherInc.detail
			}

				otherInc = Object.keys(otherInc)
				.filter((k) => otherInc[k] != null)
				.reduce((a, k) => ({ ...a, [k]: otherInc[k] }), {})



			let applicantData = {
				address: addressObj,
				altId: this.altId,
				appId: this.appId,
				confirm: this.confirm,
				consent: this.consent,
				citizen: JSON.parse(this.citizen),
				dateCreated: this.dateCreated,
				dob: this.dob,
				email: this.email,
				income: this.income,
				materials: materialsObj,
				nameFirst: this.nameFirst,
				nameLast: this.nameLast,
				notes: this.notes,
				otherInc: this.otherInc,
				pronouns: this.pronouns,
				phone: this.phone,
				school: this.school,
				status: this.status,
				user: this.user,
				videoGoal: videoGoalObj,
				videoDance: videoDanceObj,
				videoEssay: videoEssayObj,
				videoDance2: videoDance2Obj
			}

				applicantData = Object.keys(applicantData)
				.filter((k) => applicantData[k] != null)
				.reduce((a, k) => ({ ...a, [k]: applicantData[k] }), {});

			// console.log('applicant data...')
			// console.log(applicantData)
			// console.log(videoGoalObj)
			// console.log('--')

			this.$emit('save-applicant',applicantData)
		}
	},
}
</script>
<style scoped>
dt {
	float: left;
	margin-right: 1ch;
}

.warning {
	color: #ff0000;
}
</style>